import ClientPassengerInterface from '../../interfaces/client/Passenger'

export default (
  firstPassenger: ClientPassengerInterface,
  secondPassenger: ClientPassengerInterface
) =>
  firstPassenger.thirdPartyBookingNumber ===
    secondPassenger.thirdPartyBookingNumber &&
  firstPassenger.firstName.trim() === secondPassenger.firstName.trim() &&
  firstPassenger.lastName.trim() === secondPassenger.lastName.trim() &&
  firstPassenger.dateOfBirth.trim() === secondPassenger.dateOfBirth.trim()
